.container {
  overflow: hidden;
  flex: 1;
}

.badge {
  display: block;
  font-size: var(--tuna-typography-fontSize-xs);
  padding: 0 8px;
  position: absolute;
  z-index: 1;
  background-color: var(--tuna-palette-secondary-main);
  color: var(--tuna-palette-primary-contrastText);
}

.canvas {
  width: 100%;
  height: 100%;
}
